import React, { Component } from "react";

import "./styles.css";

class Widgets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itens: null
    };
  }

  componentDidMount() {
    this.setState({
      itens: this.props.itens,
      source: this.props.source ?? null
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.itens !== prevState.itens) {
      return {
        itens: nextProps.itens
      };
    }

    return null;
  }

  render() {
    return (
      <div className="row">
        {this.state.itens?.map((item, index) => (
          <div
            className={
              item.name !== "Gravação da aula" ? "col-12 col-xl-6" : "d-none"
            }
            key={index}
          >
            <div className="card info widget-card mw-100">
              <div
                className={`card-body d-flex align-items-center p-0
                ${
                  (this.state.itens[index - 1]?.item_percentage !== 100 &&
                    index - 1 !== -1 &&
                    this.props.sequentialExecution) ||
                  (item.type_id === 12 &&
                    item.item_percentage === 100 &&
                    this.state.source === "olympics")
                    ? " card-disable"
                    : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (
                    !(
                      (this.state.itens[index - 1]?.item_percentage !== 100 &&
                        index - 1 !== -1 &&
                        this.props.sequentialExecution) ||
                      (item.type_id === 12 &&
                        item.item_percentage === 100 &&
                        this.state.source === "olympics")
                    )
                  )
                    this.props.openItem(item);
                }}
              >
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <div
                    className={`mr-3 text-white bg-${
                      !this.props.isViewModeCreateActivity
                        ? item.type_color
                        : item.list.type_color
                    } p-4 rounded-left`}
                  >
                    <i
                      className={`fa fa-${
                        !this.props.isViewModeCreateActivity
                          ? item.type_icon
                          : item.list.type_icon
                      } fa-2x`}
                    ></i>
                  </div>
                  {this.props.sequentialExecution && (
                    <h4 className="m-0 mr-2">
                      <span className="badge badge-primary">{index + 1}</span>
                    </h4>
                  )}
                  <div className="text-ellipsis mr-3 w-100">
                    <div className="d-flex text-value text-info text-ellipsis align-items-center w-100">
                      <span className="flex-1 text-ellipsis">
                        {!this.props.isViewModeCreateActivity
                          ? item.title
                          : item.list.title}
                      </span>
                      {this.props.completionMark &&
                        item.item_percentage === 100 && (
                          <i
                            className="ml-2 fa fa-check-circle text-success"
                            style={{ marginRight: "1px" }}
                          />
                        )}
                      {this.props.teacher && item.type_id === 12 && (
                        <i
                          className="ml-2 fa fa-pie-chart text-muted widgets-chart-icon"
                          style={{ marginRight: "1px" }}
                          onClick={e => {
                            this.props.onEvaluationStatistics(item.obj_id);
                            e.stopPropagation();
                          }}
                        />
                      )}
                    </div>
                    <div className="text-muted text-uppercase font-weight-bold small text-ellipsis">
                      {!this.props.isViewModeCreateActivity
                        ? item.subtitle
                        : item.list.subtitle}
                    </div>
                    {this.state.source &&
                      this.state.source !== "olympics" &&
                      item.type_id === 12 && (
                        <div className="text-muted text-uppercase font-weight-bold small text-ellipsis">
                          Tentativas restantes:{" "}
                          {3 - Number(this.props.currentTry) <= 0
                            ? 0
                            : 3 - Number(this.props.currentTry)}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default Widgets;
